import React, { useState } from 'react';
import styled from 'styled-components';
import LocaleBlock from './LocaleBlock';

const CollapsibleStyles = styled.div`
  padding-bottom: 0.5rem;

  .title {
    text-transform: uppercase;
    position: relative;
    border-bottom: 1px solid var(--black);
    font-size: 1.5rem;
    padding-bottom: 0.5em;
    padding-right: 3rem;
    margin-bottom: 0.5em;

    button {
      font-size: 1em;
      background: transparent;
      border: none;
      position: absolute;
      right: 0;
      cursor: pointer;
      outline: none;
      padding-top: 0;
    }
  }

  &.collapsed {
    .body {
      display: none;
    }
  }
`;

export default function Collapsible({
  title,
  text,
  defaultCollapsed,
  className,
}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const wrapperClass = collapsed ? 'collapsible collapsed' : 'collapsible';
  return (
    <CollapsibleStyles className={`${wrapperClass} ${className}`}>
      <div
        className="title"
        role="navigation"
        onClick={() => setCollapsed(!collapsed)}
      >
        {title}
        <button type="button">{collapsed ? '+' : '-'}</button>
      </div>
      <div className="body">
        <LocaleBlock content={text} />
      </div>
    </CollapsibleStyles>
  );
}
